import { motion } from "framer-motion";
import { CalendarPlus, Gavel, Eye, Crown } from "lucide-react";

const STEPS = [
  {
    icon: CalendarPlus,
    n: "01",
    title: "Crea la competencia",
    desc: "Organiza tu evento, define la modalidad, las rondas y los MCs que participan.",
  },
  {
    icon: Gavel,
    n: "02",
    title: "Los jueces votan en vivo",
    desc: "Cada jurado registra su puntuación ronda a ronda, directo desde la app.",
  },
  {
    icon: Eye,
    n: "03",
    title: "Transparencia total",
    desc: "Brackets, votos individuales y rankings visibles para el público en tiempo real.",
  },
  {
    icon: Crown,
    n: "04",
    title: "Corona al campeón",
    desc: "Resultados instantáneos, verificables y sin espacio para la manipulación.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="relative mx-auto max-w-7xl scroll-mt-24 px-5 py-24 md:px-8 md:py-32"
    >
      <div className="mb-14 flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span className="h-px w-10 bg-[#FF5500]" />
          <span className="font-ui text-[10px] font-bold uppercase tracking-[0.3em] text-[#FF5500]">
            Cómo funciona
          </span>
        </div>
        <h2 className="max-w-2xl font-heading text-3xl font-black leading-tight tracking-tighter text-white sm:text-4xl lg:text-5xl">
          De la tarima a la tabla de posiciones en segundos
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`step-${s.n}`}
            className="group relative flex flex-col gap-5 border border-white/10 bg-[#0F172A] p-7 transition-colors duration-300 hover:border-[#FF5500]/60"
          >
            <span className="font-heading text-5xl font-black tracking-tighter text-white/5 transition-colors duration-300 group-hover:text-[#FF5500]/20">
              {s.n}
            </span>
            <s.icon className="h-7 w-7 text-[#FF5500]" strokeWidth={1.5} />
            <h3 className="font-ui text-lg font-bold text-white">{s.title}</h3>
            <p className="font-body text-sm leading-relaxed text-[#94A3B8]">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
